const loadItems = (button) => {
  const totalPagesEl = document.querySelector('[data-total-pages]');
  const currentPageEl = document.querySelector('[data-current-page]');
  const nextUrlEl = document.querySelector('[data-next-url]');

  if (!totalPagesEl || !currentPageEl || !nextUrlEl) return;

  const totalPages = parseInt(totalPagesEl.value);
  let currentPage = parseInt(currentPageEl.value);
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = nextUrlEl.value.replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  currentPageEl.value = currentPage;

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  fetch(nextUrl)
    .then(response => response.text())
    .then(responseHTML => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      const newContent = doc.querySelector('.load-more-grid');
      const container = document.querySelector('.load-more-grid');

      if (newContent && container) {
        container.insertAdjacentHTML('beforeend', newContent.innerHTML);
      }

      if (typeof colorSwatches === 'function') {
        colorSwatches();
      }

      if (typeof initHoverGallery === 'function') {
        initHoverGallery();
      }
    })
    .catch(() => {})
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector('.infinite-scroll__data');
        if (scrollData && currentPage != totalPages) {
          const scrollNextUrl = scrollData.querySelector('input[data-next-url]');
          const scrollCurrentPage = scrollData.querySelector('input[data-current-page]');
          if (scrollNextUrl) {
            scrollNextUrl.dataset.nextUrl = nextUrlScroll;
            scrollNextUrl.value = nextUrlScroll;
          }
          if (scrollCurrentPage) {
            scrollCurrentPage.dataset.currentPage = currentPage;
            scrollCurrentPage.value = currentPage;
          }
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    });
}

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      },
      { rootMargin: '0px 0px 800px 0px' }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
